import { ButtonSelect, Text, Badge, BadgeContainer } from './style';
import React, { useState } from 'react';
import { Button, Col, Row, Table, Space, Input, Tag, DatePicker } from 'antd';
import Typograpy from '../../../components/Typograpy';
import { AddContainer } from './style';
import AddButton from '../../../components/AddButton';
import ActionButton from '../../../components/ActionButton';
import { useHideModal, useShowModal } from '../../../hooks';
import {
  formData,
  initialValuesAdd,
  parentFormData,
  workStatusList,
} from './helper';
import FormCreator from '../../../components/FormCreator';
import Confirm from '../../../components/Confirm';
import categoryService from '../../../services/categories';
import groupService from '../../../services/groups';
import planService from '../../../services/plans';
import tgService from '../../../services/tggroup';
import objectService from '../../../services/objects';
import { useEffect } from 'react';
import { useShowAlert } from '../../../hooks/alert';
import FullScreen from '../../../components/Spinner/FullScreen';
import { useDataFetcher } from '../../../hooks';
import moment from 'moment';
import { Calendar } from 'react-multi-date-picker';
import { Switch } from 'antd';
import { BiEdit, BiTrash } from 'react-icons/bi';

import ModalRep from './ModalRep';
import Select from 'components/FormElements/Select';

export default () => {
  const [repetition, setRepetition] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const { success, error } = useShowAlert();
  const { regionsList } = useDataFetcher({
    province: false,
    region: true,
  });
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const [loading, setLoading] = useState(true);
  const [parentCategories, setParentCategories] = useState([]);
  const [bool, setBool] = useState(true);
  const [active, setActive] = useState(false);
  const [tempData, setTempData] = useState([]);
  const [telegramGroups, setTelegramGroups] = useState([]);
  const [important, setImportant] = useState([]);
  const [groups, setGroups] = useState([]);
  const [group, setGroup] = useState('');
  const [objects, setObjects] = useState([]);
  const [valueImportant, setValueImportant] = useState([]);

  useEffect(() => {
    const data = { group: group };
    setActive(undefined);
    group &&
      categoryService
        .getAll(data)
        .then((res) => {
          setTempData(res);
          setParentCategories(res.filter((item) => item.parent == null));
        })
        .finally(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
  }, [bool, group]);

  useEffect(() => {
    const data = { group: group };
    group && fetchPlans(data);
  }, [group]);
  useEffect(() => {
    const subcat = tempData
      .filter((item) => {
        return item.parent === active;
      })
      .map((item, index) => {
        return { ...item, key: index + 1 };
      });
    setSubCategories(subcat);
  }, [active]);

  useEffect(() => {
    fetchUserData();
    fetchImportants();
    fetchObjects();
  }, []);

  const fetchPlans = (payload) => {
    planService
      .getAllByGroup(payload)
      .then((resp) => {
        const data = resp.map((item) => {
          return {
            category: item.category,
            subCategory: item.subCategory,
            repetition: item.repetition,
            count: item.count,
            date: item.date[item.date.length - 1],
          };
        });

        const pls = getUniqueListBy(data, 'subCategory');
        setRepetition(pls);
      })
      .catch((err) => console.log(err));
  };

  const fetchObjects = () => {
    objectService
      .getAll()
      .then((resp) => {
        const objData = resp.filter((item) => item.parent === null);
        setObjects(objData);
      })
      .catch((err) => console.log(err));
  };

  const fetchImportants = () => {
    categoryService
      .importants()
      .then((resp) => {
        setImportant(
          resp.map((item) => ({
            category: item._id,
            dates: item.dates,
          }))
        );
      })
      .finally(() => setLoading(false))
      .catch((err) => console.log(err));
  };

  const getUniqueListBy = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  };

  //Add category

  const sendData = (data) => {
    let reqBody = data;
    hideModal();
    setLoading(true);
    for (let key of Object.keys(data)) {
      if (data[key] === '' || data[key] === undefined) {
        delete data[key];
      }
    }
    if (data['role']) {
      delete reqBody['role'];
    }
    if (data['regions']) {
      reqBody['regions'] = data['regions'];
    }

    categoryService
      .create(reqBody)
      .then(() => {
        setBool(!bool);
        setActive(undefined);
        success('Категория маълумоти сақланди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Категория маълумотини сақлашда хатолик', 2, 'bottom');
      });
  };
  const addCategory = () => {
    showBlured({
      title: 'Категория қўшиш',
      maxWidth: '50vw',
      height: '400px',
      withHeader: false,
      body: () => (
        <FormCreator
          formData={formData}
          cancel={hideModal}
          sendData={sendData}
          selectOptions={{
            parent: parentCategories,
            object: objects,
            group: groups,
            regions: regionsList,
            workStatus: workStatusList,
          }}
          id=''
          initialVal={{
            ...initialValuesAdd,
            group: group,
            parent: active,
          }}
        />
      ),
    });
  };

  // Update

  const initialValuesEdit = (data) => {
    let newData = {
      title: data.title,
      desc: data.desc,
      withVideo: data.withVideo,
      meet: data.meet,
      special: data.special,
      group: data.group,
      telGroupId: data.telGroupId,
      public: data.public,
      webEdit: data.webEdit,
      workStatus: data.workStatus,
      regions: data.regions,
      role: 'editor',
    };
    if (data.parent)
      newData = {
        ...newData,
        parent: data.parent,
        titleEN: data.titleEN,
        titleRU: data.titleRU,
        titleUZ: data.titleUZ,
      };

    if (data.object) newData = { ...newData, object: data.object };
    return newData;
  };

  const updateData = (id, data) => {
    hideModal();
    setLoading(true);
    categoryService
      .update(id, data)
      .then(() => {
        setBool(!bool);
        setActive(undefined);
        success('Категория маълумоти янгиланди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Категория маълумоти янгилашда хатолик', 2, 'bottom');
      });
  };

  const handleEdit = (data) => {
    showBlured({
      title: 'Категорияни таҳрирлаш',
      maxWidth: '650px',
      height: '600px',
      withHeader: false,
      body: () => (
        <FormCreator
          formData={data.parent == null ? parentFormData : formData}
          cancel={hideModal}
          sendData={updateData}
          selectOptions={{
            parent: parentCategories,
            object: objects,
            group: groups,
            regions: regionsList,
            workStatus: workStatusList,
          }}
          id={data._id}
          initialVal={initialValuesEdit(data)}
        />
      ),
    });
  };

  // Delete

  const deleteCategory = (id) => {
    hideModal();
    setLoading(true);
    categoryService
      .delete(id)
      .then(() => {
        setBool(!bool);
        if (subCategories.length != []) {
          setSubCategories((prev) => prev.filter((item) => item._id !== id));
        } else {
          setActive(undefined);
        }
        success('Категория ўчирилди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Категорияни ўчиришда хатолик', 2, 'bottom');
      });
  };

  const handleDelete = (id) => {
    showBlured({
      maxWidth: '400px',
      height: '300px',
      withHeader: false,
      body: () => (
        <Confirm agree={() => deleteCategory(id)} cancel={hideModal} />
      ),
    });
  };

  const fetchUserData = () => {
    groupService
      .getAll()
      .then((resp) => {
        setGroups(resp);
        setGroup(resp[0]._id);
      })
      .catch((err) => console.log(err));
  };

  const handleRep = (subCategory, group, date, repetition, count) => {
    const data = {
      group: group,
      category: active,
      subCategory: subCategory,
      repetition: repetition * 1,
      date: date,
      count: count * 1,
    };
    setLoading(true);
    planService
      .create(data)
      .then(() => fetchPlans({ group }))
      .finally(() => setLoading(false))
      .catch((err) => console.log(err));
    hideModal();
  };

  const getIndex = (id) => {
    return repetition.findIndex((item) => item.subCategory === id);
  };

  const handleSendImportant = (catId, impId, publicT) => {
    hideModal();

    const data = {
      subCategory: catId,
      dates: valueImportant,
      public: publicT,
    };

    impId
      ? categoryService
          .updateImportant(impId, data)
          .then(() => {
            fetchImportants();
          })
          .catch((err) => {
            error('Хатолик юз берди қайта уриниб кўринг!', 2, 'bottom');
            console.log(err);
          })
      : categoryService
          .addImportant(data)
          .then(() => {
            fetchImportants();
          })
          .catch((err) => {
            error('Хатолик юз берди қайта уриниб кўринг!', 2, 'bottom');
            console.log(err);
          });
  };

  const handleImportant = (id) => {
    let imp = important.filter((item) => item.category == id);
    let dates;
    let impId;
    if (imp) {
      dates = imp[0]?.dates.map((item) => new Date(item));
      impId = imp[0]?._id;
    }

    showBlured({
      title: 'Dolzarb',
      // maxWidth: "400px",
      height: '600px',
      withHeader: false,
      body: () => {
        const [publicT, setPublicT] = useState(false);
        return (
          <Space
            align='center'
            style={{ padding: '30px' }}
            wrap={true}
            direction='vertical'
          >
            <Space
              style={
                publicT
                  ? { color: 'black', fontWeight: 'bold' }
                  : { color: '#eee', fontWeight: 'bold' }
              }
            >
              Sayt uchun
              <Switch
                size='large'
                onChange={(checked) => setPublicT(checked)}
              />
            </Space>
            <Calendar
              shadow={false}
              weekend='highlight'
              FirstDayOfWeek='Monday'
              multiple
              value={dates ? dates : null}
              onChange={(e) => {
                let data = e.map(
                  (item) =>
                    `${item.year}-${
                      item.month < 10 ? '0' + item.month : item.month
                    }-${item.day < 10 ? '0' + item.day : item.day}`
                );
                valueImportant.length = 0;
                valueImportant.push(...data);
                setValueImportant(valueImportant);
              }}
            />
            <Button onClick={() => handleSendImportant(id, impId, publicT)}>
              {' '}
              Belgilash{' '}
            </Button>
          </Space>
        );
      },
    });
  };

  const handleRepetition = (id, group, date, rep, count = '') => {
    showBlured({
      title: 'Takroriyligi',
      maxWidth: '300px',
      // height: "600px",
      withHeader: false,
      body: () => {
        return (
          <ModalRep
            handleRep={handleRep}
            group={group}
            count={count}
            id={id}
            dateone={date}
            rep={rep}
          />
        );
      },
    });
  };

  const DeleteRepetition = (id) => {
    // const data = {
    //   category: active,
    //   subCategory: id,
    //   repetition: 4,
    // };
    setLoading(true);
    planService
      .deleteByCategory(id)
      .then(() => fetchPlans({ group }))
      .finally(() => setLoading(false))
      .catch((err) => console.log(err));
    hideModal();
  };

  const handleDeleteRepetition = (id) => {
    showBlured({
      maxWidth: '400px',
      height: '300px',
      withHeader: false,
      body: () => {
        return (
          <Confirm agree={() => DeleteRepetition(id)} cancel={hideModal} />
        );
      },
    });
  };

  function getDates(id) {
    let imp = important?.find((item) => item.category == id);
    return imp ? imp.dates : [];
  }

  const columns = [
    {
      title: 'Nomi',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Takroriyligi',
      dataIndex: 'takroriyligi',
      key: '',
      align: 'center',
      width: '160px',
      render: (props, row) => (
        <div style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
          <DatePicker
            placeholder=''
            disabled
            value={
              repetition[getIndex(row._id)]?.date
                ? moment(repetition[getIndex(row._id)]?.date)
                : null
            }
            onChange={() => {}}
          />
          <div style={{ display: 'flex', gap: '10px', flexDirection: 'row' }}>
            <Input
              disabled
              // key={props._id}
              type='number'
              onChange={() => {}}
              value={repetition[getIndex(row._id)]?.repetition}
              width='20px'
            />
            <Button
              style={{
                background: 'none',
                border: 'none',
                margin: '0',
                color: '#ff0000',
              }}
              onClick={() => handleDeleteRepetition(row._id, row.group)}
              shape='circle'
              icon={<BiTrash size={25} />}
            ></Button>
            <Button
              style={{
                background: 'none',
                border: 'none',
                margin: '0',
                color: '#c2c2c2',
              }}
              onClick={() =>
                handleRepetition(
                  row._id,
                  row.group,
                  repetition[getIndex(row._id)]?.date,
                  repetition[getIndex(row._id)]?.repetition,
                  repetition[getIndex(row._id)]?.count
                )
              }
              shape='circle'
              icon={<BiEdit size={25} />}
            ></Button>
          </div>
        </div>
      ),
    },
    {
      title: 'Dolzarb',
      dataIndex: '',
      align: 'center',
      key: 'x',
      width: '20%',
      render: (props, row) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            padding: '5px',
          }}
        >
          <div>
            <Row gutter={[20, 10]}>
              {getDates(row._id).map((item, ind) => (
                <Col key={ind + 1}>
                  <BadgeContainer>
                    <Tag color='green'>{moment(item).format('DD-MM')}</Tag>
                    <Badge
                      onClick={() =>
                        handleDeleteDate({
                          subCategory: row._id,
                          dates: [item],
                        })
                      }
                    >
                      x
                    </Badge>
                  </BadgeContainer>
                </Col>
              ))}
            </Row>
          </div>
          <Button
            style={{
              background: 'none',
              border: 'none',
              margin: '0',
              color: '#c2c2c2',
            }}
            onClick={() => handleImportant(row._id)}
            shape='circle'
            icon={<BiEdit size={25} />}
          ></Button>
        </div>
      ),
    },
    {
      width: '100px',
      align: 'center',
      title: 'Action',
      dataIndex: '',
      key: 'y',
      render: (props) => (
        <ActionButton
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          props={props}
        />
      ),
    },
  ];
  const handleDeleteDate = (payload) => {
    setLoading(true);
    categoryService
      .deleteImportant(payload)
      .then(() => {
        fetchImportants();
      })
      .catch((err) => console.log(err));
  };

  const handleSelect = (foof) => {
    setGroup(foof);
  };

  if (loading) return <FullScreen />;
  return (
    <>
      <AddContainer>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 10,
            fontWeight: 550,
          }}
        >
          {' '}
          <div>Гуруҳ</div>
          <Select
            allowClear={false}
            options={groups}
            handleChange={handleSelect}
            defaultVal={group}
          />
        </div>
        <AddButton text='Категория' formData={formData} addData={addCategory} />
      </AddContainer>
      <Row>
        <Col span={7}>
          <Typograpy>Асосий категориялар</Typograpy>{' '}
          <Space
            direction='vertical'
            size='middle'
            style={{
              display: 'flex',
              padding: '0 20px',
            }}
          >
            {parentCategories.map((item, index) => (
              <Row key={index + 1}>
                <Col span={24}>
                  <ButtonSelect
                    isActive={active == item._id}
                    onClick={() => setActive(item._id)}
                  >
                    <Text>
                      {item.title.length > 25
                        ? item.title.slice(0, 25) + '...'
                        : item.title}{' '}
                    </Text>
                    <Text>
                      {active == item._id ? (
                        <ActionButton
                          handleEdit={handleEdit}
                          handleDelete={handleDelete}
                          props={item}
                        />
                      ) : null}
                    </Text>
                  </ButtonSelect>
                </Col>
              </Row>
            ))}{' '}
          </Space>
        </Col>
        <Col span={17}>
          <Typograpy>Суб категориялар</Typograpy>
          <Space
            direction='vertical'
            size='middle'
            style={{
              display: 'flex',
              padding: '0 20px',
            }}
          >
            <Table
              bordered
              columns={columns}
              dataSource={subCategories}
              pagination={false}
            />
          </Space>
        </Col>
      </Row>
    </>
  );
};
